export default __webpack_public_path__ + "static/media/IMPORT_DATA_CREDIT.3ee2d7e4.xlsx";